import { useEffect, useContext } from 'react';

import { GeneralContext } from '../../core/app-context/GeneralContext';
import { useFetch } from './useFetch';

const baseUrl = (cep) => `https://viacep.com.br/ws/${cep}/json/`;

export function useGetAddressByCep() {
  const { setErrorMessage, setLoading } = useContext(GeneralContext);
  const { fetchUrl, loading, fetchData, error } = useFetch();

  useEffect(() => {
    setLoading(loading);
  }, [loading]);

  useEffect(() => {
    if (error) {
      setErrorMessage('Erro ao carregar enderço pelo CEP');
    }
  }, [error]);

  async function getAddressByCep(cep) {
    await fetchUrl(baseUrl(cep));
  }

  return { getAddressByCep, data: fetchData, loading };
}
